import type { ListStatusQuery } from './ListStatusQuery.generated';
import { useListStatusQuery } from './ListStatusQuery.generated';

export type ListStatus = NonNullable<
  NonNullable<ListStatusQuery['list']>['status']
>;

interface HookProps {
  idList: string;
  skip?: boolean;
}

export const useListStatus = ({
  idList,
  skip,
}: HookProps): ListStatus | null => {
  const { data } = useListStatusQuery({
    fetchPolicy: 'cache-only',
    skip,
    variables: { idList },
    waitOn: ['CurrentBoardFull'],
  });

  return data?.list?.status ?? null;
};
